<template>
  <div class="card">
    <div style="padding-left: 15px; padding-right: 15px">
      <div class="d-flex flex-column company-profile-top">
        <!-- <div class="company-profile-top-parent">
          <span style="flex: 1 1 auto"></span>
          <div class="ellipsesDropdownLayout">
            <template
                style="border: 0; background: none"
              >
                <i
                  class="fa fa-ellipsis-h"
                  aria-hidden="true"
                  style="color: #00000080"
                ></i>
              </template>
          </div>
        </div> -->
        <div class="flex-grow-1 d-flex justify-content-center" style="text-align: center; margin-top: 20px">
          <img
            v-if="workspaceImage"
            :src="workspaceImage"
            class="rounded-circle"
            style="width: 120px; height: 120px"
          />
          <div v-else class="rounded-circle d-flex align-items-center justify-content-center" style="width: 120px; height: 120px; background: #FDD03B" >
            <p style="font-size: 43px; margin: 0">{{workspaceTitleText(currentWorkspaceName)}}</p>
          </div>
        </div>
        <div class="userName">
          <h5>{{currentWorkspaceName}}</h5>
        </div>
        <div class style="margin-top: 20px; word-break: keep-all">
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Fees</div>
            <div class="col-5 value">{{fee}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Carry</div>
            <div class="col-5 value">{{carry}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Role Access</div>
            <div class="col-5 value">{{role}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">tags</div>
            <div class="col-5 value">{{tags.length>0? tags : "-"}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Number of LP's</div>
            <div class="col-5 value">{{noOfSyndicates}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Location</div>
            <div class="col-5 value">{{location}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Stage Invested</div>
            <div class="col-5 value">{{stageInvested}}</div>
          </div>
          <div class="row col-12" style="margin-bottom: 20px">
            <div class="col-7 key">Current Stage</div>
            <div class="col-5 value">{{lastFundingRound}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import api from "../../axios_api";
import EditCompanyDialog from "../../pages/Dashboard/Dialogs/EditCompany";
import config from "../../../config/settings";
export default {
  name: "spv-dashboard-profile-card",
  components: {
    [EditCompanyDialog.name]: EditCompanyDialog,
  },
  data() {
    return {
      workspaceImage: null,
      fee: "",
      carry: "",
      role: "",
      noOfSyndicates: 0,
      currentWorkspaceName: "",
    };
  },
  props:["lastFundingRound", "location", "tags", "stageInvested"],
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    ...mapGetters("contacts", ["contactData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    ...mapGetters("referrer", ["teamMembers"]),
    config() {
      return config;
    },
    image() {
    },
  },
  mounted() {
    let self = this;
    api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/currentWorkspace`).then(res => {
      const data = res.data.encrypt.success;
      if(data.logo){
        self.workspaceImage = data.logo;
      }
      self.currentWorkspaceName = data.title;
      self.carry = `${data.carry}%`;

      if(data.managementFee.type === "% Fee"){
        self.fee = `${data.managementFee.value}%`
      }else{
        self.fee = `$${data.managementFee.value}`
      }
      const userEmail = self.user.email;
      for(let item of self.teamMembers){
        if(item.email === userEmail){
          self.role = item.roleName;
          break;
        }
      }
    }).catch(err => {
      console.log("error getting current workspace : ", err);
    })
    api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/syndicateDetails`).then(res => {
      self.noOfSyndicates = res.data.encrypt.success.length;
    }).catch(err => {
      console.log("error getting syndicateDetails : ", err)
    })
  },
  watch: {
  },
  methods: {
    workspaceTitleText(name) {
      if (name && name.length > 0) {
        let text = name.split(" ");
        text =
          text.length > 1
            ? `${text[0].charAt(0)}${text[1].charAt(0)}`
            : text[0].charAt(0);
        return text;
      } else {
        return "U";
      }
    },
  },
  
};
</script>
<style lang="scss" scoped>
  .userName{
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .key{
    font-size: 14px;
    font-weight: 600;
  }
  .value{
    font-size: 14px;
    color: #0000009A;
  }
</style>